import { data } from '../../svg/ReadMore/data';
import { makeIcon } from '../makeIcon';

export const ReadMore = makeIcon(data, 'read_more', 'ReadMore');

export default ReadMore;
